import React, {Component} from 'react';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ActionCreators} from '../../data/ActionCreators';

class Navbar extends Component {
    render() {
        const {auth, navigation} = this.props;
        return (
            <nav className="navbar">
                <a href="#" className="sidebar-toggler">
                    <i data-feather="menu"></i>
                </a>
                {auth.data &&
                    <div className="navbar-content">

                    <ul className="navbar-nav">



                        <li className="nav-item dropdown nav-notifications">
                            <a className="nav-link dropdown-toggle" href="#" id="notificationDropdown" role="button"
                               data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i data-feather="bell"></i>
                                <div className="indicator">
                                    <div className="circle"></div>
                                </div>
                            </a>
                            <div className="dropdown-menu" aria-labelledby="notificationDropdown">
                                <div className="dropdown-header d-flex align-items-center justify-content-between">
                                    <p className="mb-0 font-weight-medium">No New Notifications</p>

                                </div>

                            </div>
                        </li>
                        <li className="nav-item dropdown nav-profile">
                            <a className="nav-link dropdown-toggle" href="#" id="profileDropdown" role="button"
                               data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <img src="../assets/img/user_in.png" alt="profile"/>
                            </a>
                            <div className="dropdown-menu" aria-labelledby="profileDropdown">
                                <div className="dropdown-header d-flex flex-column align-items-center">
                                    <div className="figure mb-3">
                                        <img src="../assets/img/user_in.png" alt=""/>
                                    </div>
                                    <div className="info text-center">
                                        <p className="name font-weight-bold mb-0">{auth.data.user.surname} {auth.data.user.names}</p>
                                        {auth.data.user.username !== '' && (
                                            <p className="email text-muted mb-0"> {auth.data.user.username}</p>

                                        )}
                                        {auth.data.user.email !== '' && (
                                            <p className="email text-muted mb-3"> {auth.data.user.email}</p>

                                        )}
                                    </div>
                                </div>
                                <div className="dropdown-body">
                                    <ul className="profile-nav p-0 pt-3">
                                        {/*<li className="nav-item">*/}
                                        {/*    <a href="" className="nav-link">*/}
                                        {/*        <i data-feather="user"></i>*/}
                                        {/*        <span>Account Settings</span>*/}
                                        {/*    </a>*/}
                                        {/*</li>*/}
                                        {/*<li className="nav-item">*/}
                                        {/*    <a href="javascript:;" className="nav-link">*/}
                                        {/*        <i data-feather="edit"></i>*/}
                                        {/*        <span>Edit Profile</span>*/}
                                        {/*    </a>*/}
                                        {/*</li>*/}
                                        {/*<li className="nav-item">*/}
                                        {/*    <a href="javascript:;" className="nav-link">*/}
                                        {/*        <i data-feather="repeat"></i>*/}
                                        {/*        <span>Documentation</span>*/}
                                        {/*    </a>*/}
                                        {/*</li>*/}
                                        {/*<li className="nav-item">*/}
                                        {/*    <a href="javascript:;" className="nav-link">*/}
                                        {/*        <i data-feather="repeat"></i>*/}
                                        {/*        <span>Refer A Friend</span>*/}
                                        {/*    </a>*/}
                                        {/*</li>*/}
                                        <li className="nav-item">
                                            <a onClick={ () => { this.props.login(null)

                                                localStorage.removeItem("state");
                                                window.location = "/";
                                            }} className="nav-link">
                                                <i data-feather="log-out"></i>
                                                <span>Log Out</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                }
            </nav>
        );
    }
}



// map store state to component props
const mapStateToProps = (state) => {
    // get required state from store state
    var {auth} = state;
    // return state
    return {
        auth,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            getAuthenticated: ActionCreators.getAuthenticated,
            login: ActionCreators.login,
            setSeenOnboarding: ActionCreators.setSeenOnboarding,
        },
        dispatch,
    );
};
export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
